<div class="m-4">
  <h2 class="mb-4" i18n="@@outcome-billed-contractor.mark-all-billed">Markera alla körordrar som fakturerade</h2>
  <p class="mb-5" i18n="@@outcome-billed-contractor.confirm">Detta markerar alla körordrar på denna beställning som fakturerade. Vill du gå vidare?</p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@outcome-billed-contractor.no">Nej</button>
    <button class="btn btn-primary btn-min-width" id="billBtn" type="button" (click)="bill()" [disabled]="buttonsDisabled" i18n="@@outcome-billed-contractor.yes">Ja</button>
  </div>
</div>
